
import { resetPassword } from "@/api/account.api";
import { CheckMsg } from "@/constants/message.constant";
import { ResetPasswordModel } from "@/interfaces/account.interface";
import { useUserStore } from "@/store";
type ValidateFieldCallback = (message?: string | Error) => void;
import { defineComponent, reactive, ref } from "vue";
import { useRouter } from "vue-router";
export default defineComponent({
  name: "resetPassword",
  emits: ["handleSetPassword"],
  setup() {
    const userStore = useUserStore();
    const router = useRouter();
    const ruleForm = reactive({
      email: "",
    } as ResetPasswordModel);
    const emailForm = ref();
    const rules = {
      email: [
        {
          type: "email",
          trigger: "blur",
          message: CheckMsg.CHK_MAIL2,
        },
        {
          validator: async (
            self: any,
            value: string,
            callback: ValidateFieldCallback
          ) => {
            if (!value) {
              callback(CheckMsg.CHK_MAIL);
            }
          },
          trigger: "blur",
        },
      ],
    };
    const isSending = ref(true); //email入力フォーム表示制御
    const loading = ref(false);
    const handleResetPassword = () => {
      emailForm.value?.validate(async (valid: unknown) => {
        if (valid) {
          loading.value = true;
          try {
            await resetPassword(ruleForm.email);
            await userStore.logout();

            isSending.value = false;
            loading.value = false;
          } catch (error) {
            loading.value = false;
          }
        } else {
          return false;
        }
      });
    };
    const handleBack = () => {
      router.push({ path: "/login" });
    };

    return {
      loading,
      ruleForm,
      emailForm,
      rules,
      handleResetPassword,
      handleBack,
      isSending,
    };
  },
});
